import { render, staticRenderFns } from "./FlowDetails.vue?vue&type=template&id=6a8aa4ba&scoped=true&"
import script from "./FlowDetails.vue?vue&type=script&lang=js&"
export * from "./FlowDetails.vue?vue&type=script&lang=js&"
import style0 from "./FlowDetails.vue?vue&type=style&index=0&id=6a8aa4ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8aa4ba",
  null
  
)

export default component.exports